import { Component, EventEmitter, OnInit } from '@angular/core';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { ChartDataset, ChartOptions, ChartType } from 'chart.js';
import {
  CombosConfiguration,
  FunctionsService,
  HttpService,
  MenuBreadCrumb,
  MessageService,
  TableColumns,
  TableConfiguration,
  enumActions,
  enumRules,
  params,
} from 'brainloper-ui';
import { Item } from 'app/models2/inventory/item';
import { HistoryInventory } from 'app/models2/inventory/history-inventory';
import { Provider } from 'app/models2/administration/provider';
import { Indicator } from 'app/models2/indicators/indicator';
import { Data } from 'app/models2/commos/base-response-data';
import { Warehouse } from 'app/models2/inventory/warehouse';
import { enumProviderType } from 'app/models2/commos/enum-provider-type';

@Component({
  selector: 'app-indicators-inventory',
  templateUrl: './indicators-inventory.component.html',
  styleUrls: ['./indicators-inventory.component.scss'],
})
export class IndicatorsInventoryComponent implements OnInit {
  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: 'Inicio',
      router: '/inicio',
    },
    {
      name: 'Indicadores Almacen',
      current: true,
    },
  ];

  public urlTableInventoryLevel = `${EndpointDictionary.Indicator.INDICATOR_INVENTORY_LEVEL_TABLE}`;
  public urlTableInventoryPendingPurchaseOrders = `${EndpointDictionary.Indicator.INDICATOR_INVENTORY_PENDING_ORDER_TABLE}`;
  private urlComboProvider: string = `${EndpointDictionary.Provider.PROVIDER_TYPE_COMBO}`;
  private urlGetAverageTimeOrdersInventory = `${EndpointDictionary.Indicator.INDICATOR_INVENTORY_AVERAGE_TIME_ORDER}`;
  private urlGetNumberAnnualInputsInventory = `${EndpointDictionary.Indicator.INDICATOR_INVENTORY_NUMBER_INPUTS}`;
  private urlGetNumberAnnualOutputsInventory = `${EndpointDictionary.Indicator.INDICATOR_INVENTORY_NUMBER_OUTPUTS}`;
  private urlGetePurchaseOrderStatusInventory = `${EndpointDictionary.Indicator.INDICATOR_INVENTORY_PURCHASE_ORDER_STATUS}`;
  private urlWarehouses: string = `${EndpointDictionary.Warehouse.WAREHOUSE_COMBO}`;

  public paramsWarehouse: params[] = [{ id: 'active', value: 1 }];
  public warehouses: Warehouse[];
  public isMobile: boolean = screen.width > 800 ? true : false;
  //public date: string | Date
  public today: string = this.functionEter.dateDB(new Date());
  private todayYear = new Date();
  private itemsData: Array<Item> = [];
  public total: number = -1;
  public finalTotal: string = '';

  // LEVEL INVENTORY

  public reloadComboWarehouse = new EventEmitter<any>();
  public combosConfigWarehouse: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'id',
    label: 'Bodega',
  };
  public reloadTableI = new EventEmitter<any>();
  public configurationI: TableConfiguration = {
    addPer: true,
    editPer: true,
    primaryKey: 'id',
  };
  public stockStatusColumn: TableColumns<any> = {
    ID: 'stockStatus',
    label: 'Estado Stock',
    type: 'text',
    style: {
      textAlign: 'center',
    },
  };
  public columnI: TableColumns<Item>[] = [
    {
      ID: 'code',
      label: 'Código',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'warehouse',
      label: 'Bodega',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'itemName',
      label: 'Item',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'amount',
      label: 'Cantidad',
      type: 'number',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'minStock',
      label: 'Stock Mínimo',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'maxStock',
      label: 'Stock Máximo',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
      rules: [
        {
          rule: enumRules['=='],
          valueRule: '-1',
          action: enumActions.REPLACE,
          valueAction: '',
        },
      ],
    },
    {
      ID: 'totalCostItems',
      label: 'Costo Total Items',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    this.stockStatusColumn,
  ];
  public paramsInventoryLevel: Array<params> = [
    { id: 'date', value: null },
    { id: 'warehouseId', value: 0 },
  ];
  public paramsProvider: params[] = [
    { id: 'providerTypeId', value: enumProviderType.ALMACEN },
  ];

  warehouseId: number = 0;

  // orders and Replenishments
  public reloadTablePO = new EventEmitter<any>();
  public configurationPO: TableConfiguration = {
    addPer: true,
    editPer: true,
    primaryKey: 'id',
  };

  public columnsPO: TableColumns<HistoryInventory>[] = [
    {
      ID: 'consecutive',
      label: '#',
      type: 'number',
      style: {
        textAlign: 'center',
        width: '80px',
        movil: 'no-movil',
      },
    },
    {
      ID: 'warehouse',
      label: 'Bodega',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'created',
      label: 'Fecha Creación',
      type: 'fecha',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'receptionDate',
      label: 'Fecha Recepción',
      type: 'fecha',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'requestsName',
      label: 'Solicita',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'authorizeName',
      label: 'Autoriza',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'providerName',
      label: 'Proveedor',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'itemsCount',
      label: 'Número de Items',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'totalCost',
      label: 'Costo Total',
      type: 'number',
      style: {
        textAlign: 'center',
      },
    },
  ];
  public paramsInventoryPendingPurchaseOrders: Array<params> = [
    { id: 'providerId', value: null },
    { id: 'active', value: '1' },
    { id: 'warehouseId', value: 0 },
  ];

  public color: string = '#36858A';

  //AVERAGE TIME ORDERS
  public chartLabelsAverageTimeOrder: string[] = [];
  public chartTypeAverageTimeOrder: ChartType = 'bar';
  public chartDataAverageTimeOrder: ChartDataset<'bar', number[]>[] = [
    {
      data: [],
      label: '',
      backgroundColor: this.color,
      hoverBackgroundColor: this.color,
    },
  ];

  //NUMBER INPUTS
  private paramsNumberAnnualInputs = [
    { id: 'date', value: 0 },
    { id: 'warehouseId', value: 0 },
  ];
  public chartLabelsNumberAnnualInputs: string[] = [];
  public chartTypeNumberAnnualInputs: ChartType = 'line';
  public chartDataNumberAnnualInputs: ChartDataset<'line', number[]>[] = [
    {
      data: [],
      label: '',
      fill: false,
      borderColor: this.color,
      pointBorderColor: this.color,
      pointBackgroundColor: this.color,
      backgroundColor: this.color,
      hoverBackgroundColor: this.color,
    },
  ];

  //NUMBER OUTPUTS
  private paramsNumberAnnualOutputs = [
    { id: 'date', value: 0 },
    { id: 'warehouseId', value: 0 },
  ];
  public chartLabelsNumberAnnualOutputs: string[] = [];
  public chartTypeNumberAnnualOutputs: ChartType = 'line';
  public chartDataNumberAnnualOutputs: ChartDataset<'line', number[]>[] = [
    {
      data: [],
      label: '',
      fill: false,
      borderColor: this.color,
      pointBorderColor: this.color,
      pointBackgroundColor: this.color,
      backgroundColor: this.color,
      hoverBackgroundColor: this.color,
    },
  ];

  public barChartOptions: ChartOptions = {
    responsive: true,
  };

  //PURCHASE ORDERS STATUS
  public chartLabelsPurchaseOrderStatus: string[] = [];
  public chartTypePurchaseOrderStatus: ChartType = 'bar';
  public chartDataPurchaseOrderStatus: ChartDataset<'bar', number[]>[] = [
    {
      data: [],
      label: '',
    },
  ];

  //provider combo
  private providerId: number = 0;
  public reloadComboProvider = new EventEmitter<any>();
  public combosConfigProvider: CombosConfiguration = {
    visibleField: 'providerName',
    selectionField: 'id',
    urlCombo: this.urlComboProvider,
    urlParams: this.paramsProvider,
    label: 'Proveedor',
  };

  public additionalData: Provider[] = [
    {
      providerName: 'Todos los proveedores',
      id: 0,
    },
  ];

  private additionalDataWarehouse: Warehouse[] = [
    {
      name: 'Todas las bodegas',
      id: 0,
    },
  ];

  constructor(
    private functionEter: FunctionsService,
    private message: MessageService,
    private http: HttpService
  ) {}

  async ngOnInit() {
    this.warehouses = await this.http.getDataBody(
      `${this.urlWarehouses}`,
      this.paramsWarehouse
    );
    if (this.warehouses.length > 1) {
      this.warehouses = this.additionalDataWarehouse.concat(this.warehouses);
    }
    if (this.warehouses.length === 1) {
      this.combosConfigWarehouse.selected = this.warehouses[0].id;
      this.reloadComboWarehouse.emit('selected');
    }
  }

  ngAfterViewInit() {
    this.initGraphics();
  }

  private async initGraphics() {
    await this.chosenDateAverageTimeOrder(this.todayYear.getFullYear());
    await this.chosenDateInputs(this.todayYear.getFullYear());
    await this.chosenDateOutputs(this.todayYear.getFullYear());
    await this.chosenDatePurchaseOrderStatus(this.todayYear.getFullYear());
  }

  async chosenDate($event: string) {
    this.paramsInventoryLevel[0].value = $event;
    if ($event != this.today) {
      this.columnI.splice(7, 1);
    } else {
      this.columnI.push(this.stockStatusColumn);
    }
    this.reloadTableI.emit();
  }

  async chosenDateAverageTimeOrder($event: number) {
    this.message.openLoading('Cargando', 'Calculando Indicador');
    let paramsAverageTimeOrder = [{ id: 'date', value: $event }];
    let res: Array<Indicator> = await this.http.getDataBody(
      `${this.urlGetAverageTimeOrdersInventory}`,
      paramsAverageTimeOrder
    );

    this.chartDataAverageTimeOrder[0].data = [];
    this.chartDataAverageTimeOrder[0].label = '';
    this.chartLabelsAverageTimeOrder = [];
    for (let element of res) {
      this.chartLabelsAverageTimeOrder.push(element.providerName); //x
      this.chartDataAverageTimeOrder[0].data.push(element.indicator); //y
      this.chartDataAverageTimeOrder[0].label = `${$event} promedio pedidos completados / proveedor `;
    }
    this.chartDataAverageTimeOrder[0].data.push(0);

    this.chartDataAverageTimeOrder = [...this.chartDataAverageTimeOrder];
    this.chartLabelsAverageTimeOrder = [...this.chartLabelsAverageTimeOrder];

    this.message.closeLoading();
  }

  async chosenDateInputs(date?: number, warehouseId?: number) {
    this.message.openLoading('Cargando', 'Calculando Indicador');

    if (date) {
      this.paramsNumberAnnualInputs[0].value = date;
    } else {
      date = this.paramsNumberAnnualInputs[0].value;
    }

    if (warehouseId || warehouseId === 0) {
      this.paramsNumberAnnualInputs[1].value = this.warehouseId;
    }

    let res: Array<Indicator> = await this.http.getDataBody(
      `${this.urlGetNumberAnnualInputsInventory}`,
      this.paramsNumberAnnualInputs
    );
    this.chartDataNumberAnnualInputs[0].backgroundColor = this.color;
    this.chartDataNumberAnnualInputs[0].hoverBackgroundColor = this.color;
    this.chartDataNumberAnnualInputs[0].data = [];
    this.chartDataNumberAnnualInputs[0].label = '';
    this.chartLabelsNumberAnnualInputs = [];
    for (let element of res) {
      this.chartLabelsNumberAnnualInputs.push(element.date); //x
      this.chartDataNumberAnnualInputs[0].data.push(element.count); //y
      this.chartDataNumberAnnualInputs[0].label = `número de entradas en ${date}`;
    }
    this.chartDataNumberAnnualInputs[0].data.push(0);
    
    this.chartDataNumberAnnualInputs = [...this.chartDataNumberAnnualInputs];
    this.chartLabelsNumberAnnualInputs = [...this.chartLabelsNumberAnnualInputs];

    this.message.closeLoading();
  }

  async chosenDateOutputs(date?: number, warehouseId?: number) {
    this.message.openLoading('Cargando', 'Calculando Indicador');

    if (date) {
      this.paramsNumberAnnualOutputs[0].value = date;
    } else {
      date = this.paramsNumberAnnualInputs[0].value;
    }

    if (warehouseId || warehouseId === 0) {
      this.paramsNumberAnnualOutputs[1].value = this.warehouseId;
    }

    let res: Array<Indicator> = await this.http.getDataBody(
      `${this.urlGetNumberAnnualOutputsInventory}`,
      this.paramsNumberAnnualOutputs
    );
    this.chartDataNumberAnnualOutputs[0].backgroundColor = this.color;
    this.chartDataNumberAnnualOutputs[0].hoverBackgroundColor = this.color;
    this.chartDataNumberAnnualOutputs[0].data = [];
    this.chartDataNumberAnnualOutputs[0].label = '';
    this.chartLabelsNumberAnnualOutputs = [];
    for (let element of res) {
      this.chartLabelsNumberAnnualOutputs.push(element.date); //x
      this.chartDataNumberAnnualOutputs[0].data.push(element.count); //y
      this.chartDataNumberAnnualOutputs[0].label = `número de entradas en ${date}`;
    }
    this.chartDataNumberAnnualOutputs[0].data.push(0);

    this.chartDataNumberAnnualOutputs = [...this.chartDataNumberAnnualOutputs];
    this.chartLabelsNumberAnnualOutputs = [...this.chartLabelsNumberAnnualOutputs];

    this.message.closeLoading();
  }

  async chosenDatePurchaseOrderStatus($event: number) {
    this.message.openLoading('Cargando', 'Calculando Indicador');
    let paramsePurchaseOrderStatus = [{ id: 'date', value: $event }];
    let colorState = {
      Completado: '#11d03d',
      'En proceso': '#ff7f27',
      'Pendiente por Autorizar': '#00a2e8',
    };
    let res: Array<Indicator> = await this.http.getDataBody(
      `${this.urlGetePurchaseOrderStatusInventory}`,
      paramsePurchaseOrderStatus
    );
    this.chartLabelsPurchaseOrderStatus = [];
    this.chartDataPurchaseOrderStatus = [];
    if (res.length > 0) {
      for (let element of res) {
        this.chartLabelsPurchaseOrderStatus.push(element.date); // x
        for (let [index, indicator] of element.indicators.entries()) {
          if (!this.chartDataPurchaseOrderStatus[index]) {
            this.chartDataPurchaseOrderStatus[index] = {
              data: [],
            };
          }
          this.chartDataPurchaseOrderStatus[
            index
          ].label = `Orden ${indicator.stateName}`;
          (this.chartDataPurchaseOrderStatus[index].backgroundColor =
            colorState[indicator.stateName]),
            (this.chartDataPurchaseOrderStatus[index].hoverBackgroundColor =
              colorState[indicator.stateName]),
            this.chartDataPurchaseOrderStatus[index].data.push(indicator.count); //y
        }
      }
      this.chartDataPurchaseOrderStatus[0].data.push(0);

    }
    this.chartDataPurchaseOrderStatus = [...this.chartDataPurchaseOrderStatus];
    this.chartLabelsPurchaseOrderStatus = [...this.chartLabelsPurchaseOrderStatus];
    
    this.message.closeLoading();
  }

  async dataItems($event: Data<Item[]>) {
    this.itemsData = $event.data;
    this.suma();
    if (this.itemsData.length <= 0) this.finalTotal = '0';
  }

  suma() {
    this.total = 0;
    for (const item of this.itemsData) {
      let totalCostItems =
        typeof item.totalCostItems === 'string'
          ? parseFloat((item.totalCostItems as string).replace(/\./g, ''))
          : item.totalCostItems;
      this.total += totalCostItems;
      this.finalTotal = Intl.NumberFormat('es-CO').format(this.total);
    }
  }

  changeValueProvider($event) {
    this.providerId = $event;
    this.paramsInventoryPendingPurchaseOrders[0].value = this.providerId;
    this.reloadTablePO.emit();
  }

  changeValueWarehouse(
    $event,
    type: 'inventory' | 'purchaseOrder' | 'inputs' | 'outputs'
  ) {
    this.warehouseId = $event;

    const actions = {
      inventory: () => {
        this.paramsInventoryLevel[1].value = this.warehouseId;
        this.reloadTableI.emit();
      },
      purchaseOrder: () => {
        this.paramsInventoryPendingPurchaseOrders[2].value = this.warehouseId;
        this.reloadTablePO.emit();
      },
      inputs: () => {
        this.chosenDateInputs(null, this.warehouseId);
      },
      outputs: () => {
        this.chosenDateOutputs(null, this.warehouseId);
      },
    };

    if (actions[type]) {
      actions[type]();
    }
  }
}
